var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4ElectricShock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.11 32.11a4 4 0 115.15-6.12 4 4 0 01-5.15 6.12zM71.18 16H58.39l9.47-12h-5L50.12 20h12.1l-5.58 7L53 23.65V34h10.25l-4.11-4.13L71.18 16zm-24.7 23.46a2 2 0 00-2.41-.11l-10 6.7-6.88-10.89 5-3.55A2 2 0 0033 30V18.08a2 2 0 10-4-.08v10.76L10.81 42.22a2.001 2.001 0 00-.81 1.61v12.09a2 2 0 002.295 2.087A2 2 0 0014 56V45l3.47-2.57s7.68 12.64 8 12.94a2 2 0 001.44.62H43l7.29 12a2.001 2.001 0 003.08.42 2.07 2.07 0 00.28-2.58L45.79 53a2.001 2.001 0 00-1.71-1h-11.3l12.32-8.5 9.65 8a2 2 0 002.39.22 2 2 0 00.23-3.25l-10.89-9.01z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Electric_shock.84ab7c99.svg";
export { SvgA4ElectricShock as ReactComponent };